import { render, staticRenderFns } from "./FrsProductQuantityEditor.vue?vue&type=template&id=7815d948&lang=html&"
import script from "./FrsProductQuantityEditor.vue?vue&type=script&lang=js&"
export * from "./FrsProductQuantityEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports